import { Component, OnInit, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { faSearch  } from '@fortawesome/free-solid-svg-icons';
import { Search } from 'src/app/shared/models/search.model';
import { Router } from '@angular/router';
import { MapsAPILoader } from '@agm/core';
import { Address } from 'src/app/shared/models/address.model';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {
  @Input() searchParams: Search = new Search(null, null, null, null, null, null);

  searchForm: FormGroup;
  languages = ['All languages', 'English', 'French', 'German', 'Spanish'];
  searchIcon = faSearch;

  currentWindowWidth: number;

  constructor(private router: Router, private mapsAPILoader: MapsAPILoader) { }

  ngOnInit(): void {
    this.currentWindowWidth = window.innerWidth;
    this.searchForm = new FormGroup({
      'query': new FormControl(this.searchParams.query ? this.searchParams.query : null, Validators.required),
      'location': new FormControl(this.searchParams.location ? this.searchParams.location : null, Validators.required),
      'language': new FormControl(this.searchParams.language ? this.searchParams.language : 'All languages', Validators.required)
    });

    this.searchParams.latitude = this.searchParams.latitude ? this.searchParams.latitude : null;
    this.searchParams.longitude = this.searchParams.longitude ? this.searchParams.longitude : null;
    this.loadLocation();
  }

  loadLocation(): void {
    if (!this.searchParams.location && !this.searchParams.latitude && !this.searchParams.longitude) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.searchParams.latitude = position.coords.latitude;
          this.searchParams.longitude = position.coords.longitude;
        });
      }
    } else if (this.searchParams.latitude && this.searchParams.longitude) {
      this.mapLocationFromCoordinates(this.searchParams.latitude, this.searchParams.longitude);
    } else if (this.searchParams.location) {
      this.mapsAPILoader.load().then(() => {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': this.searchParams.location}, (results: google.maps.GeocoderResult[]) => {
          if (results[0]) {
            var address = Address.createAddressFromPlace(results[0]);
            this.searchParams.latitude = address.latitude;
            this.searchParams.longitude = address.longitude;
          } else {
            this.searchParams.location = null;
            this.searchForm.get('location').setValue(null);
          }
        });
      });
    }
  }

  mapLocationFromCoordinates(lat: number, lng: number): void {
    this.mapsAPILoader.load().then(() => {
      var geocoder = new google.maps.Geocoder();
      let latlng = { lat: lat, lng: lng };
      geocoder.geocode({'location': latlng}, (results: google.maps.GeocoderResult[]) => {
        if (results[0]) {
          var address = Address.createAddressFromPlace(results[0]);
          this.searchParams.location = address.postalCode;
          this.searchForm.get('location').setValue(this.searchParams.location);
        }
      });
    });
  }

  getAddress(place: google.maps.places.PlaceResult) {
    this.searchParams.latitude = place.geometry.location.lat();
    this.searchParams.longitude = place.geometry.location.lng();
    this.onSubmit();
  }

  onSubmit() {
    let value = this.searchForm.value;
    this.router.navigate(['/search'], { queryParams: {
      query: value.query ? value.query : null,
      location: value.location ? value.location : null,
      language: value.language && value.language.indexOf('All') === -1 ? value.language : null,
      lat: this.searchParams.latitude && !value.location ? this.searchParams.latitude : null,
      lng: this.searchParams.longitude && !value.location ? this.searchParams.longitude : null
    }});
  }

  @HostListener('window:resize')
  onResize() {
    this.currentWindowWidth = window.innerWidth;
  }
}
